export class EmailPersonalizado {
  variaveis = [];

  constructor(body) {
    this.contexto = body.contexto;
    this.assunto = body.assunto;
    this.mensagem = body.mensagem;
    this.ativado = body.ativado;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setVariaveis(variaveis) {
    this.variaveis = variaveis;
  }
}